module.exports = __webpack_public_path__ + "img/pexels-painting.ccdf5788.webp";